import { Outlet } from 'react-router-dom';

export const RequireAuth = () => {
  return <Outlet />;
};
